import React from 'react';
import PropTypes from 'prop-types';
import { EN_US } from 'shared/i18n';
import Translation from '../../../../website/components/stateless/Translation';
import { pushRoute } from '../../../../modules/routing';
const propTypes = {
  onDismiss: PropTypes.func,
  locale: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  closeMobileNav: PropTypes.func,
};

const defaultProps = {
  onDismiss: undefined,
  closeMobileNav: undefined,
};

class StorageMartHeaderSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  updateSearch = e => this.setState({ search: e.target.value });

  handleKeyUp = (e) => {
    const { search } = this.state;
    if (!search) return;

    if (e.keyCode === 13) this.handleSearch(search);
  }

  handleIconClick = (e) => {
    const { search } = this.state;
    if (!search) return;

    e.preventDefault();

    this.handleSearch(search);
  }

  handleDismissMenu = () => {
    const { closeMobileNav } = this.props;
    if (closeMobileNav) closeMobileNav();
  }

  handleSearch = (userQuery) => {
    if (!userQuery) return;

    const { locale, pathname } = this.props;
    const query = userQuery.length ? `query=${userQuery}` : 'userLocation=true';

    const isUS = locale === EN_US;
    const intlPrefix = pathname === `${locale}/search` ? '/search' : `/${locale}/search`;
    const route = `${isUS ? '/search' : `${intlPrefix}`}?${query}`;
    this.handleDismissMenu();

    pushRoute(route);
  };

  render() {
    const { onDismiss, id } = this.props;
    const { search } = this.state;

    return (
      <>
        <Translation
          id="sections.enterprise.storageMartHeader.searchPlaceholder"
          defaultMessage="Enter zip/postal/city"
        >
          {text => (
            <div className="w-full md:pt-0 md:pl-0 md:pr-0">
              <div className="flex">
                <div
                  className="flex h-10 relative m-0 flex-auto rounded-l border border-r-0 border-solid border-border bg-white font-normal focus:z-[3] focus:border-primary"
                >
                  <input
                    type="search"
                    placeholder={text}
                    className="fs-unmask w-full h-full px-3 py-[0.25rem] rounded-l border-0 border-r-0"
                    onChange={this.updateSearch}
                    value={search}
                    onKeyUp={this.handleKeyUp}
                    id={id}
                    required
                    aria-label="Search"
                  />
                </div>
                <button
                  type="button"
                  onClick={this.handleIconClick}
                  className="text-white bg-black hovcusact:bg-gray-900 md:text-black md:bg-sm-btn-prim md:hovcusact:bg-sm-btn-prim-hov flex items-center rounded-r px-6 py-2.5 leading-tight"
                >
                  <i className="fa fa-fw fa-search" aria-hidden="true" />
                  <span className="sr-only">search</span>
                </button>
              </div>
            </div>
          )}
        </Translation>
        {onDismiss && (
          <Translation
            id="sections.enterprise.storageMartHeader.a11yHideSearch"
            defaultMessage="Close search"
          >
            {text => (
              <button
                type="button"
                onClick={onDismiss}
                className="w-8 flex justify-center items-center bg-transparent"
              >
                <span className="sr-only">{text}</span>
                <svg className="w-4 h-6 block" viewBox="0 0 352 512" role="presentation" aria-hidden="true">
                  <path
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                    fillRule="evenodd"
                  />
                </svg>
              </button>
            )}
          </Translation>
        )}
      </>
    );
  }
}

StorageMartHeaderSearch.propTypes = propTypes;
StorageMartHeaderSearch.defaultProps = defaultProps;

export default StorageMartHeaderSearch;
